/* ------------------------- External Dependencies -------------------------- */
import React from 'react';
import { Box } from 'atomic'
/* ---------------------------- Module Package ------------------------------ */
export default props => (<Box {...props} onClick={props.popoverClose}/>)



// WEBPACK FOOTER //
// ./src/interface/containers/popover/PopoverClose/render/index.js